























































































































































































































































































































































































































































import { Component, Watch, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import ThDropdownVue from "../components/ThDropdown.vue";
import ReportStatusVue from "@/components/TaxDeclaration/ReportStatus.vue";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ViewAccountBookVue from "@/components/AccountBookList/ViewAccountBook.vue";
import AllUserTreeVue, { UserTree } from "@/components/User/AllUserTree.vue";
import PayRollTaxVue from "../components/Payroll/PayRollTax.vue";
import ThDatePickerVue from "../components/ThDatePicker.vue";
// import HfLoading from "@/components/Loading/HfLoading";

@Component({
    ...mapGetters(["account"]),
    components: {
        "th-dropdown": ThDropdownVue,
        "th-date": ThDatePickerVue,
        "month-selector": MonthSelectorVue,
        "view-book": ViewAccountBookVue,
        "report-status": ReportStatusVue,
        "user-tree": AllUserTreeVue,
        "payroll-tax": PayRollTaxVue,
    },
})
export default class TaxDeclaration extends Vue {
    isSortByCode: boolean = false
    changeCode() {
        localStorage.setItem(
            "isSortByCode",
            this.isSortByCode ? "1" : "0"
        );
        this.fetchData()
    }
    [x: string]: any;
    showTax: boolean = false;
    collectPeriod: string = this.$store.state.collectPeriod;
    clientList: any[] = [];
    records: any[] = [];
    taxList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 111,
        },
        {
            text: "无税款",
            id: 1,
        },
        {
            text: "有税款",
            id: 0,
        },
    ];
    chargeList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未申报",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "申报中",
            id: 3,
        },
        {
            text: "完成申报",
            id: 4,
        },
        {
            text: "申报异常",
            id: 5,
        },
        {
            text: "无需申报",
            id: 6,
        },
        {
            text: "作废中",
            id: 0,
        },
        {
            text: " 作废成功",
            id: 7
        },
        {
            text: " 作废失败",
            id: 8
        }
    ];
    tjList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未提交",
            id: 1,
        },
        {
            text: "部分提交",
            id: 3,
        },
        {
            text: "全部提交",
            id: 4,
        },
    ];
    checkList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 99,
        },
        {
            text: "未检查",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "检查中",
            id: 3,
        },
        {
            text: "检查通过",
            id: 4,
        },
        {
            text: "检查异常",
            id: 5,
        },
    ];
    accountList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 0,
        },
        {
            text: "未扣款",
            id: 1,
        },
        {
            text: "等待中",
            id: 2,
        },
        {
            text: "扣款中",
            id: 3,
        },
        {
            text: "完成扣款",
            id: 4,
        },
        {
            text: "扣款异常",
            id: 5,
        },
        {
            text: "无需扣款",
            id: 6,
        },
    ];
    addTaxList: DataTable.DropItem[] = [
        {
            text: "全部",
            id: 11,
        },
        {
            text: "一般纳税人",
            id: 0,
        },
        {
            text: "小规模纳税人",
            id: 1,
        },
    ];
    height: string = "371px";
    toUrl() {
        // const shell = require("electron").shell;
        window.open("https://12366.chinatax.gov.cn/bsfw/onlinetaxation/main");
    }
    // 修改页数SIze
    changeSize(size: number) {
        this.pageSize = size;
        this.delButton = "批量下载";
        this.perButton = "批量申报"
        this.showCheck = false;
        this.notAllow = false;
        this.showPerChange = false;
        this.clickPer = false;
        this.batch = 0;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
    }
    // 人员组织
    accounterName: string = "所属人姓名";
    // 打开tree
    isTree: boolean = false;
    openTree() {
        this.isTree = !this.isTree;
    }
    // 展开tree时,暂存tmp,以便关闭dialog时,直接从tmp展示tree
    tmp: UserTree | null = null;
    treeExpand(data: UserTree) {
        this.tmp = data;
    }
    // 点击tree中的名字(node)
    isScope: boolean = false;
    handleNodeClick(data: Account) {
        this.isScope = true;
        if (data.name) this.accounterName = data.name;
        this.currentPage = 1;
        this.$store.dispatch("clearSearchKey");
        this.accounterNo = data.no;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
        this.isTree = false;
    }
    // 关闭tree
    closeTree() {
        this.isTree = false;
    }
    // 搜索
    searchQuery: string = "";
    startSearch() {
        this.currentPage = 1;
        this.fetchData();
    }
    // 日期筛选
    dateValue: string = ""
    chooseDate(date: string) {
        // let days = new Date(2022,2,0).getDate()
        this.dateValue = date
        this.$nextTick(() => {
            this.fetchData()
        })
    }
    //改变时间
    period: string = ""; // 日期
    dateRange: string[] = [
    ]
    changeDate(date: string, end: string) {
        this.$store.dispatch("setClosePeriod", null);
        this.$store.dispatch("changeStartPeriod", "202001");
        this.$store.dispatch("changeCurrentPeriod", end);
        this.period = date;
        let start = this.period.substring(0, 4) + "-" + ((+this.period.substring(4) + 1) < 10 ? ("0" + (+this.period.substring(4) + 1).toString()) : (+this.period.substring(4) + 1).toString()) + "-" + "01"
        let day = ((new Date(+(this.period.substring(0, 4)), +(this.period.substring(4)) + 1, 0).getDate()).toString())
        let month = this.period.substring(0, 4) + "-" + ((+this.period.substring(4) + 1) < 10 ? ("0" + (+this.period.substring(4) + 1).toString()) : (+this.period.substring(4) + 1).toString())
        let ent = (month + "-" + day)
        this.dateRange = [
            start,
            ent
        ]
        this.dateValue = "";
        this.currentPage = 1;
        if (this.flowType === 33) this.getList();
        else this.fetchData();
    }
    batch: number = 0;
    showCheck: boolean = false;
    clickPer: boolean = false;
    notAllow: boolean = false;
    delButton: string = "";
    perButton: string = "批量申报";
    showPerChange: boolean = false; //展示修改时间
    checkChange() { }
    // 批量切换
    batchList(command: string) {
        if (command === "批量下载") {
            this.batch = 1;
            this.showCheckBox(command);
        } else if (command === "无需申报") {
            this.batch = 3;
            this.declare(command);
        } else if (command === "设为零申报") {
            this.batch = 4;
            this.zeroChange(command);
        } else if (command === "撤销零申报") {
            this.batch = 5;
            this.revoke(command);
        } else if (command === "批量复制工资") {
            this.batch = 6;
            this.copyPay(command);
        } else if (command === "批量检查") {
            this.batch = 7;
            this.showChecks(command);
        }
        else if (command === "批量扣款") {
            this.batch = 8;
            this.showKw(command);
        }
        else if (command === "批量回写") {
            this.batch = 9;
            this.showHx(command);
        }
        else if (command === "批量取数") {
            console.log(command)
            this.batch = 10;
            this.showQs(command);
        }
        else {
            console.log(command)
            this.batch = 2;
            this.showPerCheck(command);
        }
        console.log(this.flowType);
    }
    // 点击批量下载
    showCheckBox(command: string) {
        if (this.delButton === "批量下载") {
            // if (this.delIds.length === 0) {
            //     this.delButton = "取消";
            // };
            this.delButton = "取消";
            if (this.notAllow) {
                this.dowmLoad();
            } else {
                this.delButton = "取消";
                this.showCheck = true;
                this.notAllow = true;
            }
        } else {
            this.delButton = "批量下载";
            this.showCheck = false;
            this.notAllow = false;
            this.batch = 0;
        }
    }
    // 点击批量修改时间
    showPerCheck(command: string) {
        if (command === "批量申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量申报") {
            this.batchClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量申报";
            this.batch = 0;
        }
    }
    showChecks(command: string) {
        console.log(command)
        if (command === "批量检查") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量检查") {
            console.log("批量检查")
            this.checkClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量检查";
            this.batch = 0;
        }
    }
    // 批量扣款
    showKw(command: string) {
        if (command === "批量扣款") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量扣款") {
            console.log("批量扣款")
            this.pays();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量扣款";
            this.batch = 0;
        }
    }
    // 批量回写
    showHx(command: string) {
        console.log(command)
        if (command === "批量回写") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量回写") {
            console.log("批量回写")
            this.reWrite();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量回写";
            this.batch = 0;
        }
    }
    // 批量取数
    showQs(command: string) {
        if (command === "批量取数") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量取数") {
            console.log("批量取数")
            this.qs();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量取数";
            this.batch = 0;
        }
    }
    // 批量无需申报
    declare(command: string) {
        if (command === "无需申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "无需申报") {
            this.declareClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "无需申报";
            this.batch = 0;
        }
    }
    // 批量取数
    async qs() {
        let arr = [];
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            await this.$confirm("亲,确定要批量取数?", "温馨提示");
            Vue.axios.post("/incometaxdeclarationoperatings/reset", {
                ids: arr,
                endPeriod: this.period
            }).then((res) => {
                this.$message({
                    type: "warning",
                    message: "取数成功",
                });
                this.fetchData();
            }).catch(() => {
                this.fetchData();
            });
        }
    }
    // 批量回写
    async reWrite() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            await this.$confirm("亲,确定要 申报回写 选中的工资记录吗?", "温馨提示");
            const res = await Vue.axios.post("paysheet/rewrite", {
                id: ids,
                endPeriod: this.period
            });
            if (res.data) {
                if (res.data.message) {
                    this.$message({
                        type: "warning",
                        message: res.data.message,
                    });
                }
                this.fetchData();
            }
        }
    }
    // 批量扣款
    pays() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            this.$confirm(`亲，确定要执行扣款？`, "温馨提示").then(
                (action: any) => {
                    if (action === "confirm") {
                        Vue.axios
                            .post(
                                `tax/record/save?period=${this.period}&ids=${ids
                                }&flowType=${this.flowType}&isPay=${1}`,
                                {}
                            )
                            .then((res) => {
                                this.fetchData();
                            });
                    }
                }
            );
        } else {
            this.$message.warning("请选择需要扣款的");
        }
    }
    revoke(command: string) {
        if (command === "撤销零申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量撤销") {
            this.revokeClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "撤销零申报";
            this.batch = 0;
        }
    }
    copyPay(command: string) {
        if (command === "批量复制工资") {
            console.log("go");
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量复制") {
            this.copyClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "批量复制工资";
            this.batch = 0;
        }
    }
    async copyClick() {
        let successCount = 0;
        let failCount = 0;
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked) {
                const res = await Vue.axios.post(`paysheetList/copy?idStrs=${this.clientList[i].accountBookId}&period=${this.period}`, {});
                if (res.data.data === 1) successCount++;
                else failCount++;
            }
        }
        this.$message({
            type: "warning",
            message: `成功复制${successCount}家工资记录，跳过${failCount}家工资记录！`,
        });
        await this.fetchData();

    }
    revokeClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(`zero/period/del?period=${this.period}&ids=${ids}`, {})
                .then((res) => {
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要撤销零申报的账套");
        }
    }

    // 批量无需申报
    zeroChange(command: string) {
        if (command === "设为零申报") {
            this.showCheck = true;
            this.clickPer = true;
            this.perButton = "取消";
        } else if (this.perButton === "批量设为") {
            this.zeroClick();
        } else if (this.perButton === "取消") {
            this.showPerChange = false;
            this.showCheck = false;
            this.clickPer = false;
            this.perButton = "设为零申报";
            this.batch = 0;
        }
    }
    zeroClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(`zero/period/save?period=${this.period}&ids=${ids}`, {})
                .then((res) => {
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要零申报的账套");
        }
    }
    declareClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            // this.$message({
            //   type: "warning",
            //   message: "亲，未在申报期内，无法申报！"
            // });
            ids = arr.join(",");
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period
                    }&ids=${ids}&flowType=${this.flowType}&isPay=${3}`,
                    {}
                )
                .then((res) => {
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要申报的账套");
        }
    }
    // 下拉
    accountStatus: DataTable.DropItem = this.accountList[0];
    chargeStatus: DataTable.DropItem = this.chargeList[0];
    tjStatus: DataTable.DropItem = this.tjList[0];
    addTaxStaxtus: DataTable.DropItem = this.addTaxList[0];
    taxStaxtus: DataTable.DropItem = this.taxList[0];
    checkStatus: DataTable.DropItem = this.checkList[0]

    // 分页
    pageSize: number = 15;
    currentPage: number = 1;
    totalElements: number = 5;

    searchKey: string = "";
    // 是否展示check td
    isShowTd() {
        if (this.batch === 2 || this.batch === 1 || this.batch === 3 || this.batch === 4 || this.batch === 5 || this.batch === 6 || this.batch === 7 || this.batch === 8 || this.batch === 9 || this.batch === 10) return true
        else return false
    }
    idCheckDisable(data: any) {
        if (this.batch === 7 || this.batch === 6 || this.batch === 1) return false;
        else if (this.batch === 2) {
            if ((data.taxState != 1 && data.taxState != 5 && data.taxState != 7 && data.submitState != 3)) return true;
        }
        else if (this.batch === 4 || this.batch === 5) {
            if (data.taxState != 1 && data.taxState != 5) return true;
        }
        else if (this.batch === 3) {
            if (data.taxState != 1 && data.taxState != 5 && data.taxState != 7) return true;
        }
        else if (this.batch === 8) {
            if ((data.payBalance === 0 || data.payBalance === null) || (data.payState != 1 && data.payState != 5) || data.taxState != 4) return true;
        }
        else if (this.batch === 9) {
            if (data.taxState != 4) return true;
        }
        else return false
    }
    isShowCheck(data: any) {
        if (this.batch === 7 && !data.isWarning && data.taxState === 4) return true;
        else if (this.batch === 6 && data.isWarning) return true;
        else if (this.batch === 10 && !data.isWarning) return true;
        else if (this.batch === 2 && !data.isWarning) return true;
        else if (this.batch === 4 || this.batch === 5 || this.batch === 8 || this.batch === 3 || this.batch === 9) return true;
        else if (this.batch === 1 && !data.isWarning) return true;
        else return false;
    }
    // 获取社保期间
    getSbTime() {
        let time = this.$utils.dateAdd(new Date(), "m", -1)
        console.log(this.$utils.simpleDateFormat(new Date(time), "m"))
        return this.$utils.simpleDateFormat(new Date(time), "m")
    }
    //征期延期判断
    getIsOpen() {
        let time = this.$utils.dateAdd(new Date(), "m", -1)
        if (this.period >= this.$utils.simpleDateFormat(new Date(time), "m")) {
            return true
        } else return false
    }
    mounted() {
        if (localStorage.getItem("isSortByCode")) {
            this.isSortByCode = localStorage.getItem("isSortByCode") === "1" ? true : false
        }
        if (this.$route.query.accountStatus) {
            let accountStatus = Number(this.$route.query.accountStatus);
            this.accountStatus = <DataTable.DropItem>(
                this.getAccountStatus(1, accountStatus)
            );
        }
        if (this.$route.query.accounterNo) {
            this.accounterNo = this.$route.query.accounterNo;
        }
        // this.fetchData();
    }
    chooseType() {
        this.currentPage = 1;
        this.fetchData();
    }
    taxSuccess(val: any) {
        this.showTax = false;
        this.batchClicks(val);
        // this.fetchData();
    }
    closeTax() {
        this.showTax = false;
        // this.fetchData();
    }
    // 自然人报税
    batchClicks(val: any) {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}&isLastMonth=${val}`,
                    {}
                )
                .then((res) => {
                    if (res.data) {
                        this.$msgbox({
                            message: res.data,
                            title: "温馨提示",
                            confirmButtonText: "确定",
                            showCancelButton: false,
                        }).then((action: any) => {
                        });
                    }
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要申报的账套");
        }
    }
    actiondList = [
        {
            name: "财务报表",
            id: 101
        },
        {
            name: "增值税",
            id: 102
        },
        {
            name: "所得税",
            id: 103
        },
        {
            name: "其他税种",
            id: 104
        },
    ]
    actionIds = [101, 102, 103, 104]
    showAction: boolean = false;
    // 批量报税
    closeBatch() {
        this.actionIds = [101, 102, 103, 104]
        this.showAction = false
    }
    batchAdd() {
        let arr = [];
        let ids = "";
        if (this.actionIds.length === 0) {
            this.$message("请选择税种")
            return
        }
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        ids = arr.join(",");
        Vue.axios
            .post(
                `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}&actionIds=${this.actionIds.join(",")}`,
                {}
            )
            .then((res) => {
                this.fetchData();
                this.actionIds = [101, 102, 103, 104]
                this.showAction = false
            });
    }
    batchClick() {
        let arr = [];
        let ids = "";
        if (this.flowType === 2) {
            this.showTax = true;
            return;
        }
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            // this.$message({
            //   type: "warning",
            //   message: "亲，未在申报期内，无法申报！"
            // });
            if (this.purchase === 0 || this.purchase === 2) {
                this.showAction = true
            } else {
                ids = arr.join(",");
                Vue.axios
                    .post(
                        `tax/record/save?period=${this.period}&ids=${ids}&flowType=${this.flowType}`,
                        {}
                    )
                    .then((res) => {
                        this.fetchData();
                    });
            }
        } else {
            this.$message.warning("请选择需要申报的账套");
        }
    }
    // 批量检查
    checkClick() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            // this.$message({
            //   type: "warning",
            //   message: "亲，未在申报期内，无法申报！"
            // });
            ids = arr.join(",");
            Vue.axios
                .post(
                    `tax/record/save?period=${this.period}&ids=${ids
                    }&flowType=${this.flowType}&isPay=${4}`,
                    {}
                )
                .then((res) => {
                    this.fetchData();
                });
        } else {
            this.$message.warning("请选择需要检查的账套");
        }
    }
    // 批量下载
    dowmLoad() {
        let arr = [];
        let ids = "";
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.clientList[i].checked)
                arr.push(this.clientList[i].accountBookId);
        }
        if (arr.length > 0) {
            ids = arr.join(",");
            let url = `${Vue.axios.defaults.baseURL}uibot/get/result?period=${this.period}&ids=${ids}&flowType=${this.flowType}`;
            this.$store.dispatch("toggleDownload", true);
            this.$utils.sendToElectron("download", url);
            this.notAllow = false
            this.fetchData();
        } else {
            this.$message.warning("请选择需要下载的账套");
        }
    }
    // 获取数据
    accounterNo: string = "";
    fetchData() {
        this.batch = 0;
        this.showCheck = false;
        let name =
            this.addTaxStaxtus.text === "全部" ? "" : this.addTaxStaxtus.text;
        let isZero = this.taxStaxtus.text === "全部" ? "" : this.taxStaxtus.id;
        let charge =
            this.chargeStatus.text === "全部" ? "" : this.chargeStatus.id;
        let account =
            this.accountStatus.text === "全部" ? "" : this.accountStatus.id;
        let check =
            this.checkStatus.text === "全部" ? "" : this.checkStatus.id;
        let submitState =
            this.tjStatus.text === "全部" ? "" : this.tjStatus.id;
        Vue.axios
            .post(
                `tax/record/list?accountId=${this.$store.state.account.id
                }&period=${this.period}&page=${this.currentPage - 1}&size=${this.pageSize
                }&flowType=${this.flowType
                }&query=${this.searchQuery.trim()}&taxState=${charge}&payState=${account}&checkState=${check}&addtax=${name}&accounterNo=${this.accounterNo
                }&isZero=${isZero}&submitState=${submitState}&isZeroPeriod=${this.isZeroPeriod}&gmtModified=${this.dateValue}&isSortByCode=${this.isSortByCode}`,
                {}
            )
            .then((res) => {
                res.data.content.forEach((v: any) => {
                    v.checked = false;
                });
                for (let i = 0; i < res.data.content.length; i++) {
                    if (res.data.content[i].gmtModified != null) {
                        res.data.content[i].gmtModified = this.getTime(
                            new Date(res.data.content[i].gmtModified)
                        );
                    }
                }
                this.clientList = res.data.content;
                this.totalElements = res.data.totalElements;
                this.$forceUpdate();
            });
    }
    // 转化时间
    getTime(date: any) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        let minute = date.getMinutes();
        minute = minute < 10 ? "0" + minute : minute;
        return y + "-" + m + "-" + d;
    }
    getAccountStatus(type: number, code: number) {
        if (type === 1) {
            for (let i = 0; i < this.accountList.length; i++) {
                if (this.accountList[i].id === code) return this.accountList[i];
            }
        }
    }
    getStatus(type: number, code: number) {
        if (type === 0) {
            for (let i = 0; i < this.chargeList.length; i++) {
                if (this.chargeList[i].id === code) return this.chargeList[i].text;
            }
        } else if (type === 1) {
            for (let i = 0; i < this.accountList.length; i++) {
                if (this.accountList[i].id === code) return this.accountList[i].text;
            }
        }
        else if (type === 2) {
            for (let i = 0; i < this.checkList.length; i++) {
                if (this.checkList[i].id === code) return this.checkList[i].text;
            }
        }
        else if (type === 3 && (this.purchase === 0 || this.purchase === 2)) {
            for (let i = 0; i < this.tjList.length; i++) {
                if (this.tjList[i].id === code) {
                    return this.tjList[i].text;
                }
            }
        }
    }

    handleCurrentChange(val: number) {
        this.currentPage = val;
        this.showCheck = false;
        this.batch = 0;
        if (this.flowType === 33 || this.flowType === 44) this.getList();
        else this.fetchData();
    }

    inAccountBook(data: AccountBookList.AccountBook) {
        Vue.axios.post(`accountbooks/` + data.id).then((res) => {
            this.$store.dispatch("changeAccounBook", res.data);
            this.$utils.setTaxType(res.data);
            this.$utils.getRemarks();
            this.$router.push("/voucherlist");
        });
    }

    /**
     * 客户列表checkbox选中的事件及逻辑处理
     */

    // 全选
    checkAll: boolean = false;
    changeAll(val: boolean) {
        for (let i = 0; i < this.clientList.length; i++) {
            if (this.batch === 10 && !this.clientList[i].isWarning)
                this.$set(this.clientList[i], "checked", val);
            if (this.batch === 7) {
                if (!this.clientList[i].isWarning && this.clientList[i].taxState === 4) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 8) {
                if (this.clientList[i].payBalance != 0 && this.clientList[i].payBalance != null && (this.clientList[i].payState === 1 || this.clientList[i].payState === 5) && this.clientList[i].taxState === 4) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 9) {
                if (this.clientList[i].taxState === 4) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 1 && !this.clientList[i].isWarning)
                this.$set(this.clientList[i], "checked", val);
            if (this.batch === 2) {
                if (
                    (this.clientList[i].taxState === 1 ||
                        this.clientList[i].taxState === 5 || this.clientList[i].submitState === 3) &&
                    !this.clientList[i].isWarning
                ) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch == 3) {
                if (
                    (this.clientList[i].taxState === 1 ||
                        this.clientList[i].taxState === 5 || this.clientList[i].taxState === 5)
                ) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch == 4) {
                if (
                    this.clientList[i].taxState === 1 ||
                    this.clientList[i].taxState === 5
                ) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch == 5) {
                if (
                    this.clientList[i].taxState === 1 ||
                    this.clientList[i].taxState === 5
                ) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
            if (this.batch === 6) {
                if (this.clientList[i].isWarning) {
                    this.$set(this.clientList[i], "checked", val);
                }
            }
        }
    }
    // 监听全选
    @Watch("clientList", { deep: true })
    vouchersChange(val: Voucher.Voucher[]) {
        let all = true;
        let hasSelect = false;
        for (let i = 0; i < val.length; i++) {
            if (val[i].checked) {
                hasSelect = true;
            }
        }
        if (this.delButton === "批量下载") {
            this.delButton = "取消";
            if (this.clickPer) this.perButton = "取消";
        }
        if (hasSelect) {
            this.delButton = "批量下载";
            if (this.clickPer) {
                if (this.batch === 3) {
                    this.perButton = "无需申报";
                } else if (this.batch == 4) {
                    this.perButton = "批量设为";
                } else if (this.batch == 5) {
                    this.perButton = "批量撤销";
                } else if (this.batch == 6) {
                    this.perButton = "批量复制";
                }
                else if (this.batch == 7) {
                    this.perButton = "批量检查";
                }
                else if (this.batch == 8) {
                    this.perButton = "批量扣款";
                }
                else if (this.batch == 9) {
                    this.perButton = "批量回写";
                }
                else if (this.batch == 10) {
                    this.perButton = "批量取数";
                }
                else {
                    this.perButton = "批量申报";
                }
            }
        } else this.delButton = "批量下载";
        for (let i = 0; i < val.length; i++) {
            if (!val[i].checked) {
                all = false;
                break;
            }
        }
        if (val.length === 0) all = false;
        this.checkAll = all;
    }
    showImport: boolean = false;
    showReport(data: any) {
        if (data) {
            // if (data.isWarning) return;
            this.records = data;
            this.showImport = true;
        }
    }
    closeImport() {
        this.fetchData();
        this.showImport = false;
    }
    // 修改客户
    showInfo: boolean = false;
    bookData: any | null = null;
    accountModify(data: any) {
        Vue.axios.get(`accountbooks/${data.accountBookId}`).then((res) => {
            this.bookData = res.data;
            this.showInfo = true;
        });
    }
    // 模态框 close
    closeInfo() {
        this.showInfo = false;
    }
    infoSuccess() {
        this.showInfo = false;
        this.fetchData();
    }
    purchase: number = 0;
    flowType: number = 1;
    statistics: any = [];
    total: any = {};
    // 获取统计数据
    getList() {
        let flowType = null;
        if (this.flowType === 44) {
            flowType = 1;
        } else {
            flowType = "";
        }
        let no = "";
        if (this.accounterNo === "") no = this.$store.state.account.no;
        else no = this.accounterNo;
        Vue.axios
            .get(
                `uibot/count?period=${this.period}&page=${this.currentPage - 1
                }&size=${this.pageSize}&accountNo=${no}&flowType=${flowType}`
            )
            .then(res => {
                this.statistics = res.data.data.content;
                this.totalElements = res.data.data.totalElements;
                this.total = res.data.total;
                this.$forceUpdate();
            });
    }
    // 选择类型
    isZeroPeriod: string | number = "";
    changeType(type: number) {
        this.getSbTime()
        this.addTaxStaxtus = this.addTaxList[0];
        this.accountStatus = this.accountList[0];
        this.chargeStatus = this.chargeList[0];
        this.taxStaxtus = this.taxList[0];
        this.tjStatus = this.tjList[0]
        this.currentPage = 1;
        this.isZeroPeriod = "";
        this.dateValue = "";
        // @ts-ignore
        this.$refs.monthSelect.getSb(false)
        if (type === 0) {
            if (this.flowType === 33) {
                this.accounterNo = "";
                this.accounterName = "所属人姓名";
            }
            this.purchase = 0;
            this.flowType = 1;
            this.fetchData();
        } else if (type === 1) {
            this.checkStatus = {
                text: "全部",
                id: 99,
            }
            if (this.flowType === 33) {
                this.accounterNo = "";
                this.accounterName = "所属人姓名";
            }
            this.purchase = 1;
            this.flowType = 2;
            this.fetchData();
        }
        else if (type === 5) {
            this.checkStatus = {
                text: "全部",
                id: 99,
            }
            if (this.flowType === 33) {
                this.accounterNo = "";
                this.accounterName = "所属人姓名";
            }
            this.purchase = 3;
            this.flowType = 3;
            // @ts-ignore
            this.$refs.monthSelect.getSb(true)
            this.$nextTick(() => {
                this.fetchData();
            })
        }
        else if (type === 6) {
            this.checkStatus = {
                text: "全部",
                id: 99,
            }
            if (this.flowType === 33) {
                this.accounterNo = "";
                this.accounterName = "所属人姓名";
            }
            this.purchase = 4;
            this.flowType = 4;
            this.fetchData();
        }
        else if (type === 3) {
            if (this.flowType === 33) {
                this.accounterNo = "";
                this.accounterName = "所属人姓名";
            }
            this.purchase = 2;
            this.flowType = 1;
            this.isZeroPeriod = 1;
            this.fetchData();
        } else if (type === 4) {
            this.batch = 0;
            this.flowType = 44;
            this.getList();
        } else {
            this.batch = 0;
            this.flowType = 33;
            this.getList();
        }
    }
    // 重置
    reSet(data: any) {
        this.$msgbox({
            message: "是否清空申报状态",
            title: "温馨提示",
            confirmButtonText: "确定",
            showCancelButton: true,
        }).then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .post(
                        `tax/record/reset?accountBookId=${data.accountBookId}&period=${this.period}&flowType=${this.flowType}`,
                        {}
                    )
                    .then((res) => {
                        this.fetchData();
                    });
            }
        });
    }
    // 扣款
    pay(data: any) {
        if (data.accountBookId) {
            this.$confirm(`亲，确定要执行扣款？`, "温馨提示").then(
                (action: any) => {
                    if (action === "confirm") {
                        Vue.axios
                            .post(
                                `tax/record/save?period=${this.period}&ids=${data.accountBookId
                                }&flowType=${this.flowType}&isPay=${1}`,
                                {}
                            )
                            .then((res) => {
                                this.fetchData();
                            });
                    }
                }
            );
        }
    }
    // 作废
    cancel(data: any) {
        if (data.accountBookId) {
            this.$confirm(`亲，确定要执行作废？`, "温馨提示").then(
                (action: any) => {
                    if (action === "confirm") {
                        Vue.axios
                            .post(
                                `tax/record/save?period=${this.period}&ids=${data.accountBookId
                                }&flowType=${this.flowType}&isPay=${2}`,
                                {}
                            )
                            .then((res) => {
                                this.fetchData();
                            });
                    }
                }
            );
        }
    }
    // 无需申报
    oneKeyFn(id: number) {
        this.$utils.oneKeyLogin(id, this, "一键登录");
    }

    uploadDBVisible = false;
    currentBookId: null | number = null;
    currentBookName: null | string = null;
    uploadText = "上传";
    uploadDisabled = true;
    async retryUpload(mes?: any, isHistory = false) {
        if (!isHistory) {
            this.uploadDisabled = false;
            this.uploadText = "重试";
        } else {
            this.uploadDisabled = true;
            this.historyDisabled = false;
        }
        this.$notify({
            type: "error",
            title: "温馨提示",
            message: `个税更正上传失败${mes ? ", " + mes : ""}`,
            duration: 3000
        });
    }
    async uploadDB(isHistory = false) {
        if (this.currentBookId) {
            this.uploadDisabled = true;
            this.historyDisabled = true;
            try {
                const res = await this.$utils.ptaxPlugin(this.currentBookId, this, "个税上传", this.$store.state.env);
                if (res.status === 200) {
                    if (res.data.taxState === 4) {
                        this.uploadDisabled = false;
                        if (!isHistory) {
                            this.uploadDBVisible = false;
                            try {
                                await Vue.axios.post("http://localhost:3070/ptax/plugin/reset/unlock", { t: 1 });
                            } catch (e) {

                            }
                        }
                        this.uploadHistoryVisible = false;
                        this.historyDisabled = false;
                        this.ptaxPercent = 0;
                        this.uploadText = "上传";
                        this.$utils.sendToElectron("unlock-operate");
                        this.$notify({
                            type: "success",
                            title: "温馨提示",
                            message: isHistory ? "上传历史文件成功" : "个税更正上传成功",
                            duration: 3000
                        });
                        if (isHistory) {
                            this.resetPtax(this.clickBookId!, this.clickBookName!);
                        }
                    } else {
                        await this.retryUpload(res.data.resultMessage, isHistory);
                    }
                } else {
                    await this.retryUpload(undefined, isHistory);
                }
            } catch (e) {
                await this.retryUpload(e, isHistory);
            }
        }
    }

    ptaxResetData: any = null;
    ptaxTip = `<span>更正之后, 请及时</span>
                <h3 style='display: inline-block'>上传</h3>
                <span>, 以免历史数据丢失!</span>`;
    ptaxPercent = 0;
    async ptaxCheckUpload() {
        let progressing = true;
        this.uploadDisabled = true;
        for (let i = 0; i < 100 && progressing; i++) {
            await this.$utils.wait(2500);
            const res = await Vue.axios({
                url: "http://localhost:3070/ptax/plugin/reset/check",
                method: "GET"
            });
            this.ptaxTip = `
                <span>程序正在运行中...</span>
                <span>${res.data.data.message}</span>
            `;
            if (res.data.data) {
                this.ptaxPercent = res.data.data.percent;
                this.ptaxResetData = res.data;
            }

            if (res.data.code === 200 || res.data.code === 202 || res.data.code === 203) {
                progressing = false;

                if (this.ptaxResetData.code === 200) {
                    this.$notify({
                        type: "success",
                        title: "温馨提示",
                        message: "个税更正登录结束",
                        duration: 3000
                    });
                    this.uploadDisabled = false;
                } else if (this.ptaxResetData.code === 202) {
                    this.$notify({
                        type: "error",
                        title: "温馨提示",
                        message: this.ptaxResetData.data.error,
                        duration: 6000
                    });
                    this.ptaxTip = `<span>登录异常，请手动操作，若手动登录成功更正之后再上传，若没有手动登录，请直接点击上传按钮！</span>`;
                    if (!this.ptaxResetData.data.needUpload) {
                        this.uploadDBVisible = false;
                        this.$utils.sendToElectron("unlock-operate");
                    } else {
                        this.uploadDisabled = false;
                    }
                } else if (this.ptaxResetData.code === 203) {
                    this.$notify({
                        type: "error",
                        title: "温馨提示",
                        message: this.ptaxResetData.data.error,
                        duration: 6000
                    });
                    this.uploadHistoryVisible = true;
                }
                return;
            } else {
                continue;
            }
        }
        return null;
    }

    uploadHistoryVisible = false;
    historyDisabled = true;
    clickBookId: number | null = null;
    clickBookName: string | null = null;
    ptaxClose = false;
    async resetPtax(id: number, name: string) {
        this.ptaxClose = false;
        this.ptaxTip = `<span>更正之后, 请及时</span>
            <h3 style='display: inline-block'>上传</h3>
            <span>, 以免历史数据丢失!</span>`;
        this.currentBookId = id;
        this.clickBookId = id;
        this.clickBookName = name;
        this.currentBookName = name;
        const res = await this.$utils.ptaxPlugin(id, this);
        this.$utils.sendToElectron("prevent-operate");
        this.uploadDBVisible = true;


        if (res.data.code === 200) {
            try {
                // await Vue.axios.post("http://localhost:3070/ptax/plugin/reset/lock", { id, name });
            } catch (e) {

            }
            this.ptaxCheckUpload();
            console.log("will upload");
        } else if (res.data.code === 201) {
            this.uploadHistoryVisible = true;
            this.historyDisabled = false;
            this.uploadDisabled = true;
            this.currentBookId = res.data.data.accountBookId;
            this.ptaxTip = `<h3>${res.data.message}</h3>`;
            try {
                // await Vue.axios.post("http://localhost:3070/ptax/plugin/reset/lock", { id, name });
            } catch (e) {

            }
        } else if (res.data.code === 210) {
            this.$utils.sendToElectron("unlock-operate");
            this.uploadHistoryVisible = false;
            this.currentBookId = null;
            this.ptaxTip = `<span>${res.data.message}</span>`;
            this.uploadDisabled = true;
            this.ptaxClose = true;
            this.$notify({
                type: "warning",
                title: "温馨提示",
                message: res.data.message,
                duration: 6000
            });
        } else {
            if (res.data.code === 400) {
                this.$utils.sendToElectron("unlock-operate");
                this.currentBookId = null;
                this.ptaxTip = `<span>${res.data.message}</span>`;
                this.uploadDisabled = true;
                this.ptaxClose = true;
            } else if (res.data.message.includes("connect ECONNREFUSED")) {
                this.$utils.sendToElectron("unlock-operate");
                this.ptaxTip = "服务未初始化成功，可以尝试重启助手...";
                this.ptaxClose = true;
                this.uploadDisabled = true;
            } else if (res.data.message.includes("请先关闭个税客户端")) {
                this.$utils.sendToElectron("unlock-operate");
                this.ptaxTip = res.data.message;
                this.ptaxClose = true;
                this.uploadDisabled = true;
            } else {
                this.currentBookId = null;
                this.ptaxTip = `<span>${res.data.message}</span>`;
                this.uploadDisabled = true;
            }
        }

    }

    async uploadHistory() {
        this.uploadDB(true);
    }
}
